/* global module, require */
const THREE = require('three');

module.exports = geo => new THREE.BufferGeometry().fromGeometry(geo);
